module.exports = __webpack_public_path__ + "img/manual3.9839c521.png";